<div class="pt-3" style="width:100%; padding-right:0px">
    <div class="main">
        <div class="header">
             <!-- Menu button enables for small screen (mobile) -->
             <div class="me-4 d-block d-md-none">
                <i class="fa fa-bars" (click)="showSideBarMenu()" style="font-size: 28px;" aria-hidden="true"></i>
            </div>
            
            <div style="font-size: 20px; font-weight:600; font-family:Raleway;">CSE Section / CSE Master Listing</div>
           
            <div class="downloadContainer" *ngIf="tableData.length >= 1">
                <app-download-csv [apiEndPoint]="csvDownloadAPI" [filterParams]="cseParams" [fileName]="csvFileName"></app-download-csv>
            </div>
            
            <div class="addCSETEXT" [ngStyle]="{'margin-left':  tableData.length >=1 ? '' : 'auto' }"
                (click)="goToCSEForm()">Add CSE</div>
        </div>

        <div class="tableContainer">
            <div class="tableTop">
                <div class="leftTableTop col-9" *ngIf="showFilterContainer">

                    <app-filter componentName="cseListing" (filterParams)="responseOnFilter($event)"></app-filter>

                </div>

                <div class="rightTableTop col-3">
                    <div class="searchContainer">
                        <i class="fa fa-search" style="cursor: pointer;" aria-hidden="true"></i>
                        <input (change)="tableSearch($event)" [(ngModel)]="searchCSE"
                            style="border:none; outline:none; margin-left:5px; width:100%" placeholder="Search CSE" />
                    </div>
                    <div class="filterTextContainer" style="margin-left: 5px;" (click)="tableFilter()">
                        <img src="assets/images/filterIcon.svg" alt="Download Icon" style="margin-left: 2px;" />
                        <span style="margin-left: 2px;">Filters</span>
                    </div>
                </div>
            </div>
            <div [ngStyle]="{'height': showFilterContainer ? '65vh' : '73vh'}">
                <app-table [columnList]="columnList" [tableData]="tableData"
                    (paginationVal)="handlePagination($event)" tableFor="cseList" [totalData]="totalData"></app-table>
            </div>
        </div>
    </div>
</div>